import { atom } from 'jotai';

export const isAffiliateLinkModalOpenAtom = atom(false);
